import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { CSSProperties, useMemo } from 'react';
import { Cell, Row } from 'react-table';

import { Td } from './cellStyle';

interface IProps {
  row: Row;
  cell: Cell;
  borderRight?: boolean;
  tableBodyStyle?: CSSProperties;

  // reordering props
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  isGrabbing?: boolean;
}

const isCheckboxColumn = (cell: Cell) => cell?.column?.id === 'selection';

const CellView = ({
  row,
  cell,
  borderRight,
  tableBodyStyle,
  ...rowReorderingCellProps
}: IProps) => {
  const cellContentDependencies = isCheckboxColumn(cell) ? [cell] : [cell?.value];

  const cellContent = useMemo(
    () => cell.render('Cell', rowReorderingCellProps),
    [cellContentDependencies]
  );

  return (
    <Td
      isRowSelected={row.isSelected}
      borderRight={borderRight}
      {...{
        ...cell.getCellProps({
          style: {
            flex: cell.column?.flex || cell.column?.width,
            minWidth: cell.column.minWidth,
            ...tableBodyStyle,
            padding: cell.column?.padding,
          },
        }),
      }}
    >
      {cellContent}
    </Td>
  );
};

export default CellView;
